import { useMemo } from "react";

function useUser(role) {
  const setUser = (user) => {
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("tokenKey", user.token);
    role && localStorage.setItem("role", role);
  };
  const getUser = () => {
    const user = localStorage.getItem("user");
    if (!user) return null;
    return JSON.parse(user);
  };
  const getToken = () => {
    return localStorage.getItem("tokenKey");
  };
  const getRole = () => {
    return localStorage.getItem("role");
  };
  const company = useMemo(() => {
    const companyDetails = JSON.parse(localStorage.getItem("user"));
    if (!companyDetails) return null;

    return companyDetails.company;
  }, []);

  const getPermission = () => {
    const permissions = localStorage.getItem("permission");
    const isApproved = JSON.parse(localStorage.getItem("is_approved"));
    return {
      allow: permissions,
      isApproved
    };
  }

  const getLoggedInUserDetail = () => {
    const user = getUser();
    const role = getRole();

    if (role === "admin") {
      const name = localStorage.getItem("name") || "";
      const email = localStorage.getItem("email") || "";
      return {
        name,
        email,
      };
    }

    return {
      name: user?.company?.primary_contact_name || "",
      email: user?.email || "",
    };
  };

  return {
    getUser,
    getToken,
    getRole,
    setUser,
    company,
    getLoggedInUserDetail,
    getPermission
  };
}

export default useUser;
